<template>
  <subdomain-link
    :href="href"
    :root="root"
    class="font-bold inline-flex items-center px-1 pt-1 border-b-2 font-medium focus:outline-none duration-150"
    :class="classes"
  >
    <slot></slot>
  </subdomain-link>
</template>

<script>
  export default {
    props: {
      href: String,
      active: {
        type: Boolean,
        default: false,
      },
      root: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      classes() {
        return this.active
          ? 'border-primary-500 focus:border-primary-400 dark:border-primary-700 dark:focus:border-primary-600'
          : 'border-transparent hover:border-gray-300 focus:text-gray-700 focus:border-gray-300';
      },
    },
  };
</script>
